import { GET_GROUP_MODEL_FIELD_PERMISSIONS_REQUEST } from '../constants/get_group_data.constants';

export const getGroupModelFieldPermissionsRequest = payload => ({
    type: GET_GROUP_MODEL_FIELD_PERMISSIONS_REQUEST, payload,
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/redux/actions/get_group_model_field_permissions.actions.js